module.exports = __webpack_public_path__ + "static/media/04.fdb5ac59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preparation/04.jpg
// module id = 37
// module chunks = 0